<div class="liner-service-form-page">
  <form [formGroup]="linerServiceForm">
    <mat-card>
      <mat-card-content style="text-align: end;">
        <mat-hint style="color: red;">{{showStatus}} </mat-hint>
        @if (showDeactivateToggle) {
          <mat-slide-toggle (change)="openDeactivateForm($event)" [(ngModel)]="checked"
          [ngModelOptions]="{standalone: true}">Deactivate Liner Service</mat-slide-toggle>
        }
        @if (showReactivateToggle) {
          <mat-slide-toggle (change)="openReactivateForm($event)" [(ngModel)]="checked"
          [ngModelOptions]="{standalone: true}" >Reactivate Liner Service</mat-slide-toggle>
        }
      </mat-card-content>
      <mat-card-content [ngClass]="{'form-readonly':this.id.value}">
        <mat-form-field>
          <mat-label>Line</mat-label>
          <mat-select formControlName="lineId" placeholder="Select Line" required="true" (selectionChange)="setLineValueChangeEvent($event.value)">
            <mat-option>
              <ngx-mat-select-search  [searching]="searching" [formControl]="lineSearchCtrl"
                noEntriesFoundLabel="'no matching found'" placeholderLabel="Find Line">
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option [value]="null">None</mat-option>
            @for (item of filteredLines | async; track item) {
              <mat-option [value]="item.id">
                {{ item.name }} ({{item.code}})
              </mat-option>
            }
          </mat-select>
          @if (lineId.invalid && lineId.touched && lineId.hasError('required')) {
            <mat-error>
              Line is Required
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label>Consortium</mat-label>
          <mat-select formControlName="consortiumId" placeholder="Select Consortium" required="true">
            <mat-option>
              <ngx-mat-select-search  [searching]="searching" [formControl]="consortiumSearchCtrl"
                noEntriesFoundLabel="'no matching found'" placeholderLabel="Find Consortium">
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option [value]="null">None</mat-option>
            @for (c of filteredConsortium | async; track c) {
              <mat-option [disabled]="c.status=='DEACTIVATED'" [value]="c.parentId">
                {{ c.name }}
              </mat-option>
            }
          </mat-select>
          @if (consortiumId.invalid && consortiumId.touched && consortiumId.hasError('required')) {
            <mat-error>
              Consortium is Required
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label>Terminal/POL</mat-label>
          <mat-select formControlName="polId" placeholder="Select POL" required="true" (selectionChange)="setDestinationsValueChangeEvent($event.value)">
            <mat-option>
              <ngx-mat-select-search  [searching]="searching" [formControl]="polSearchCtrl"
                noEntriesFoundLabel="'no matching found'" placeholderLabel="Find POL">
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option [value]="null">None</mat-option>
            @for (cd of filteredConsortiumDest | async; track cd) {
              <mat-option [disabled]="cd.deactivated || destinationId.value==cd.destinationId" [value]="cd.destinationId">
                {{ cd.destinationName }} ({{cd.destinationCode}})
              </mat-option>
            }
          </mat-select>
          @if (polId.invalid && polId.touched && polId.hasError('required')) {
            <mat-error>
              Terminal/POL is Required
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label>Final Destination</mat-label>
          <mat-select formControlName="destinationId" placeholder="Select Destination" required="true" (selectionChange)="setDestinationsValueChangeEvent($event.value)">
            <mat-option>
              <ngx-mat-select-search  [searching]="searching" [formControl]="destinationSearchCtrl"
                noEntriesFoundLabel="'no matching found'" placeholderLabel="Find Destination">
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option [value]="null">None</mat-option>
            @for (d of filteredDestinations | async; track d) {
              <mat-option [disabled]="polId.value==d.id" [value]="d.id">
                {{ d.name }} ({{d.code}})
              </mat-option>
            }
          </mat-select>
          @if (destinationId.invalid && destinationId.touched && destinationId.hasError('required')) {
            <mat-error>
              Destination is Required
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label>Total Transit Time</mat-label>
          <input formControlName="transitTime" (change)="checkTotalTransitTime()" type="number" [min]="1" autocomplete="off" matInput placeholder="Enter Transit Days" required>
          @if (transitTime.invalid && transitTime.touched && transitTime.hasError('required')) {
            <mat-error>
              Total Transit Time is Required
            </mat-error>
          }
          @if (transitTime.invalid && transitTime.touched && transitTime.hasError('pattern')) {
            <mat-error>
              Enter valid Transit Time
            </mat-error>
          }
        </mat-form-field>
      </mat-card-content>
      <mat-card-content [ngClass]="{'form-readonly':this.id.value}">
        <h4>Liner Services</h4>
        <div class="line-container">
          <table class="table table-border">
            <thead class="text-nowrap fx-align-space-evenly-stretch fx-row-wrap">
              <th style="flex: 1 1 18%; box-sizing: border-box;" class="width">POL/Transhipment Port</th>
              <th style="flex: 1 1 18%; box-sizing: border-box;" class="width">Destination</th>
              <th style="flex: 1 1 18%; box-sizing: border-box;" class="width">Mode</th>
              <th style="flex: 1 1 18%; box-sizing: border-box;" class="width">Transit Time</th>
              <th style="flex: 1 1 18%; box-sizing: border-box;" class="width">Arrival Day POL</th>
            </thead>
            <tbody>
              @for (item of linerServices.controls; track item; let i = $index) {
                <ng-container formArrayName="linerServiceDetails">
                  <tr class="fx-align-space-evenly-stretch fx-row-wrap" [formGroupName]="i">
                    <td style="flex: 1 1 18%; box-sizing: border-box;">
                      <mat-form-field appearance="fill" class="readonly-wrapper">
                        <mat-select formControlName="portId" placeholder="Select POL/Transhipment Port" required>
                          <mat-option [value]="null">None</mat-option>
                          @for (item of destinations; track item) {
                            <mat-option [value]="item.id">
                              {{item.name}} ({{item.code}})
                            </mat-option>
                          }
                        </mat-select>
                        @if (linerServices.controls[i].get('portId').errors?.required) {
                          <mat-error class="mt-1">
                            Required
                          </mat-error>
                        }
                      </mat-form-field>
                    </td>
                    <td style="flex: 1 1 18%; box-sizing: border-box;">
                      <mat-form-field appearance="fill">
                        @if (i==0) {
                          <mat-select (selectionChange)="destinationChanged(item,i)" formControlName="destinationId" placeholder="Select Destination" required>
                            <mat-option [value]="null">None</mat-option>
                            @for (d of consortiumDestinations; track d) {
                              <mat-option [disabled]="checkDestinationDeactivateCondition(d,true)" [value]="d.destinationId">
                                {{d.destinationName}} ({{d.destinationCode}})
                              </mat-option>
                            }
                          </mat-select>
                        }
                        @if (i!=0) {
                          <mat-select (selectionChange)="destinationChanged(item,i)" formControlName="destinationId" placeholder="Select Destination" required="true">
                            <mat-option>
                              <ngx-mat-select-search  [searching]="searching" [formControl]="destinationSearchCtrl"
                                noEntriesFoundLabel="'no matching found'" placeholderLabel="Find Destination">
                                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
                              </ngx-mat-select-search>
                            </mat-option>
                            <mat-option [value]="null">None</mat-option>
                            @for (d of filteredDestinations | async; track d) {
                              <mat-option [disabled]="checkDestinationDeactivateCondition(d,false)" [value]="d.id">
                                {{ d.name }} ({{d.code}})
                              </mat-option>
                            }
                          </mat-select>
                        }
                        @if (linerServices.controls[i].get('destinationId').errors?.required) {
                          <mat-error class="mt-1">
                            Required
                          </mat-error>
                        }
                      </mat-form-field>
                    </td>
                    <td style="flex: 1 1 18%; box-sizing: border-box;">
                      <mat-form-field appearance="fill" [ngClass]="{'readonly-wrapper':i==0}">
                        <mat-select formControlName="mode" placeholder="Select Mode" required>
                          <mat-option [value]="null">None</mat-option>
                          @for (item of modes; track item) {
                            <mat-option [value]="item">
                              {{item}}
                            </mat-option>
                          }
                        </mat-select>
                        @if (linerServices.controls[i].get('mode').errors?.required) {
                          <mat-error class="mt-1">
                            Required
                          </mat-error>
                        }
                      </mat-form-field>
                    </td>
                    <td style="flex: 1 1 18%; box-sizing: border-box;">
                      <mat-form-field appearance="fill" [ngClass]="{'readonly-wrapper':i==0}">
                        <input matInput type="number" formControlName="transitTime" (change)="checkTotalTransitTime()" placeholder="Select Transit Time" autocomplete="off" required>
                        @if (linerServices.controls[i].get('transitTime').errors?.required) {
                          <mat-error class="mt-1">
                            Required
                          </mat-error>
                        }
                        @if (linerServices.controls[i].get('transitTime').errors?.pattern) {
                          <mat-error class="mt-1">
                            Enter Valid Time
                          </mat-error>
                        }
                      </mat-form-field>
                    </td>
                    <td style="flex: 1 1 18%; box-sizing: border-box;">
                      <mat-form-field appearance="fill" [ngClass]="{'readonly-wrapper':i==0}">
                        <mat-select formControlName="arrivalDayPol" placeholder="Select Arrival Day Pol" required>
                          <mat-option [value]="null">None</mat-option>
                          @for (item of portOfLoadings; track item) {
                            <mat-option [value]="item.key">
                              {{item.label}}
                            </mat-option>
                          }
                        </mat-select>
                        @if (linerServices.controls[i].get('arrivalDayPol').errors?.required) {
                          <mat-error class="mt-1">
                            Required
                          </mat-error>
                        }
                      </mat-form-field>
                    </td>
                  </tr>
                </ng-container>
              }
            </tbody>
          </table>
        </div>
      </mat-card-content>
      <mat-card-actions>
        @if (!id.value && addPermission) {
          <button mat-button color="primary" (click)="onSave()" style="width: 10%;margin-right: 10px;">Save</button>
        }
        <button mat-button color="cancel" (click)="onCancel()" style="width: 10%;">Cancel</button>
      </mat-card-actions>
      <mat-card-content>
        @if (id.value) {
          <div class="audit-log">
            <button mat-stroked-button type="button" [class.active]="viewLog"
                (click)="linerServiceForm.get('viewLog').setValue(!viewLog)">
                <mat-icon>history</mat-icon> View Log
            </button>
          </div>
        }
        @if (viewLog) {
          <app-history [referenceType]="'LINER'" [referenceId]="id.value"></app-history>
        }
      </mat-card-content>
    </mat-card>
  </form>
</div>
